import React from 'react';
import {Flex, Link, Skeleton, Text} from '@chakra-ui/react';
import {ObjectId} from 'bson';
import {useAccountWithLogo} from '../../../hooks/api/accountWithLogo';
import _ from 'lodash';
import {Link as HttpLink} from '@carbon/icons-react';
import {CompanyLogo} from '../../Icons/CompanyLogo';

export const BuilderPreviewAccountCell = ({
  accountId,
}: {
  accountId: ObjectId;
}) => {
  const {data: account, isPending} = useAccountWithLogo(accountId);

  if (isPending || !account) {
    return <Skeleton h="6" speed={0} w="30%" />;
  }

  return (
    <Flex alignItems="center" gap="4">
      <CompanyLogo domain={account.domain} name={account.name} />
      <Flex direction="column">
        <Text>{account.name}</Text>
        <Flex gap="2" alignItems="center">
          <Text fontWeight="thin" color="gray.500">
            {account.domain}
          </Text>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={`https://${account.domain}`}
            _hover={{color: '#E61957'}}
            onClick={(e) => e.stopPropagation()}
          >
            <HttpLink />
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};
